import { useCallback } from 'react';
import { calculateFieldValue } from '../../utils/calculations';
import { FormDataType } from '@tw/tw-component-library';
import {
  FormSchemaConfig,
  EnhancedSection,
  EnhancedGroupedSection,
  isEnhancedSection,
} from '../../types/form/schema.types';

export const useFormCalculations = () => {
  const processCalculations = useCallback(
    (schema: FormSchemaConfig, data: FormDataType): Partial<FormDataType> => {
      const updates: Partial<FormDataType> = {};
      // Process schema-level calculations first
      if (schema.calculations) {
        Object.entries(schema.calculations).forEach(
          ([fieldName, calculationRule]) => {
            updates[fieldName] = calculateFieldValue(calculationRule, data);
          }
        );
      }

      // Process field-level calculations
      const processSection = (
        section: EnhancedSection | EnhancedGroupedSection
      ) => {
        if (isEnhancedSection(section) && section.fields) {
          section.fields.forEach((field) => {
            if (field.calculations) {
              const calculatedValue = calculateFieldValue(
                field.calculations,
                data
              );

              // Only update if the value has changed
              if (data[field.name] !== calculatedValue) {
                updates[field.name] = calculatedValue;
              }
            }
          });
        }

        // Process nested sections in grouped sections
        if ('sections' in section && section.sections) {
          section.sections.forEach(processSection);
        }
      };

      schema.sections.forEach(processSection);

      return updates;
    },
    []
  );

  return { processCalculations };
};
